const borders = {
  none: 0,
  '1px': '1px solid #DEE3ED',
  '2px': '2px solid #DEE3ED',
  '3px': '4px solid #DEE3ED',
  '4px': '5px solid #DEE3ED',
  '5px': '6px solid #DEE3ED',
};

export default borders;
